import LTR from "@brand-icons/ploom/zero-tobacco/zero-tobacco-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ZeroTobaccoIcon = iconFactory("ZeroTobaccoIcon", LTR);
